import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot } from '@angular/router';

import { EMPTY, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AccountService } from 'app/core';
import { PropertiesService } from './properties.service';
import { PropertyPagination } from './properties.types';
import { Property } from 'app/modules/projects/projects.types';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { SetEthanContext } from '@state/ethan/ethan.action';
import { Store } from '@ngxs/store';
import { PropertyDealsComponent } from './details/deals/deals.component';
import { RelatedToType } from '@shared/enums';
@Injectable({
  providedIn: 'root',
})
export class PropertiesResolver {
  constructor(
    private _propertiesService: PropertiesService,
    private _accountService: AccountService,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._propertiesService.accountId = accountData.id;
    });
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<{ pagination: PropertyPagination; properties: Property[] }> {
    return this._propertiesService.getProperties();
  }
}

@Injectable({
  providedIn: 'root',
})
export class PropertiesPropertyResolver {
  constructor(
    private _router: Router,
    private _propertiesService: PropertiesService,
    private _accountService: AccountService,
    private readonly snackBar: MatSnackBar,
    private readonly store: Store,
  ) {
    this._accountService.currentAccount.subscribe((accountData) => {
      this._propertiesService.accountId = accountData.id;
    });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Property> {
    return this._propertiesService.getPropertyById(route.paramMap.get('id')).pipe(
      tap((property) => this.store.dispatch(new SetEthanContext(property, RelatedToType.Property))),
      catchError((error) => {
        this.snackBar.open('Requested Property does not exist', '', {
          panelClass: ['error-snackbar'],
          duration: 6000,
        });

        this._router.navigate(['/properties']);

        return EMPTY;
      }),
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class PropertyDeactivateGuard implements CanDeactivate<PropertyDealsComponent> {
  constructor(private store: Store) {}
  canDeactivate(
    component: PropertyDealsComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    // Perform your state updates here
    this.store.dispatch(new SetEthanContext(null, null));
    return true;
  }
}
